module.exports = {"googleAnalytics":{"trackingId":"UA-106125679-1"},"firebase":{"cloudFunctionUrl":"https://us-central1-trouble-brewing-staging.cloudfunctions.net"},"campaign":{"url":"https://campaign.dev.troublebrewing.com"},"facebook":{"pixelId":"1234"}}


//////////////////
// WEBPACK FOOTER
// ./config.json
// module id = MmR0
// module chunks = 0